import { React, useState } from "react";
import { CiPlay1 } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import ContextMenu from "./ContextMenu/ContextMenu";

// made for the service button in the services page option bar , may be reused later in other pages else should be renamed to servicebutton/link
function NestedOption({
  optionId,
  sectionId,
  optionPath,
  optionText,
  contextMenuOption,
  icon,
  children,
  fieldId,
  isAgent,
}) {
  const initialContextMenu = {
    x: 0,
    y: 0,
    show: false,
  };

  const [contextMenu, setContextMenu] = useState(initialContextMenu);
  const [isOpen, setIsOpen] = useState(false);

  const handleContextMenu = (e) => {
    e.preventDefault();
    const { pageX, pageY } = e;
    setContextMenu({
      x: pageX,
      y: pageY,
      show: true,
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu(initialContextMenu);
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <li key={optionId}>
        <div className="d-flex align-items-baseline gap-1">
          {children && children.length > 0 ? (
            <p
              className={`list-arrow ${isOpen ? "is-open" : ""}`}
              onClick={handleClick}
            >
              {<CiPlay1 size={12} />}
            </p>
          ) : (
            <p className={"hidden-arrow"}>{<CiPlay1 size={12} />}</p>
          )}

          {!isAgent ? (
            <p className={`nested-list-item`} onContextMenu={handleContextMenu}>
              {
                <NavLink to={optionPath}>
                  {icon} {optionText}
                </NavLink>
              }
            </p>
          ) : (
            <p className={`nested-list-item`} onContextMenu={handleContextMenu}>
              {icon} <span className="grey-onhover">{optionText}</span>
            </p>
          )}
          {contextMenu.show && (
            <ContextMenu
              x={contextMenu.x}
              y={contextMenu.y}
              closeContextMenu={handleCloseContextMenu}
              formId={optionId}
              sectionId={sectionId}
              contextOptions={contextMenuOption}
              fieldId={fieldId}
            />
          )}
        </div>
        {
          <ul className={isOpen ? "list-is-open" : "list-is-closed"}>
            {children}
          </ul>
        }
      </li>
    </>
  );
}

export default NestedOption;
